import _ from 'lodash';
import {resetEntryDescModelsAction, setEntryDescFavEditModeAction, setEntryDescFavIDsAction, toggleEntryDescFavAction} from "module/edesc/action/EntryDescActions";
import {combineReducers} from 'redux'
import {createReducer} from 'util/redux'
import {EntryDesc} from 'generated/JavaTOmodifications'

const byId = createReducer<{ [id in number]: EntryDesc }>({}, builder => builder
	.addCase(resetEntryDescModelsAction, (state, {payload}) => {
		const newState = _.keyBy(payload, "id");
		// ignore unchanged server responses
		if (_.isEqual(newState, state)) return state
		return newState
	}),
)
const allIds = createReducer<number[]>([], builder => builder
	.addCase(resetEntryDescModelsAction, (state, {payload}) => {
		const newState = _.map(payload, "id");
		// ignore unchanged server responses
		if (_.isEqual(newState, state)) return state
		return newState
	}),
)

let lastSavedFavState: number[] = []
const fav = createReducer<number[]>([], builder => builder
	.addCase(setEntryDescFavEditModeAction, (state, {payload}) => {
		if (payload.status) lastSavedFavState = _.cloneDeep(state)
		if (payload.reset) return lastSavedFavState
		return state
	})
	.addCase(setEntryDescFavIDsAction, (state, {payload}) => payload)
	.addCase(toggleEntryDescFavAction, (state, {payload}) => {
		const {entryDescId, forceAdd} = payload
		if (!entryDescId) return state
		if (!forceAdd && state.includes(entryDescId)) {
			return state.filter((i: any) => i !== entryDescId);
		} else {
			return _.uniq([entryDescId, ...state]).slice(0, 26);
		}
	}),
)
const favEditMode = createReducer<boolean>(false, builder => builder
	.addCase(setEntryDescFavEditModeAction, (state, {payload}) => payload.status),
)

export const EntryDescReducerNS = {EntryDesc: combineReducers({byId, allIds, fav, favEditMode})}
export type EntryDescStateType = { EntryDesc: ReturnType<typeof EntryDescReducerNS.EntryDesc> }